<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-card>
      <v-toolbar>
        <router-link
          v-if="isRecurring"
          :to="{
            path: `/paymentrequests/${intentId}`
          }"
          ><button class="view-request-btn">View Request</button></router-link
        >
        <router-link
          v-if="hasPromotionalCode"
          :to="{
            path: `/promocodes/${promotionalCodeId}`
          }"
          ><button class="view-request-btn">View Promocode</button></router-link
        >
        <v-spacer></v-spacer>
        <v-toolbar-title
          ><span class="headline">{{ title }}</span></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon dark color="black">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <TransactionHistoryTable
        :search="search"
        :transactionHistory="transactionHistory"
        :transactionStatuses="transactionStatuses"
        :loading="loading"
        @loadMoreTransactionHistory="loadMoreTransactionHistory"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import TransactionHistoryTable from "@/components/transaction/TransactionHistoryTable.vue";
import { parseToFloat, CURRENCY_FORMATER } from "@/services/Formatting.js";
import { API, graphqlOperation } from "aws-amplify";

const DEFAULT_AMOUNT_OF_RECORDS_TO_RETRIEVE_FROM_BACKEND = 20;

const SEARCH_CATEGORY = {
  ByOrderNumber: "byOrderNumber"
};

export default {
  components: {
    TransactionHistoryTable
  },
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    },
    transactionStatuses: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    },
    tenantAlias: {
      type: String,
      required: true
    },
    dialog: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      search: "",
      loading: false,
      transactionHistory: [],
      nextToken: null
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.loadTransactionHistory().catch(e => {
          this.$logger.error(e);
        });
      } else {
        this.clearData();
        this.close();
      }
    }
  },
  computed: {
    hasPromotionalCode() {
      return this.value.hasPromotionalCode;
    },
    promotionalCodeId() {
      return this.value.promotionalCodeId;
    },
    isRecurring() {
      return this.value.isRecurring;
    },
    intentId() {
      return this.value.intentId;
    },
    orderNumber() {
      return this.value.orderNumber;
    },
    firstName() {
      return this.value.firstName;
    },
    lastName() {
      return this.value.lastName;
    },
    title() {
      return `${this.orderNumber} - ${this.firstName} ${this.lastName}`;
    },
    searchCategory() {
      return SEARCH_CATEGORY.ByOrderNumber;
    }
  },
  methods: {
    async getTransactionHistory(nextToken) {
      const searchTransactionLog = `
          query SearchTransactionLog(
            $body: QuerySearchTransactionLogBodyInput
          ) {
            searchTransactionLog(body: $body) {
              nextToken
              data{
                transactionLogId
                logDate
                amount
                currencyText
                transactionStatus
              }
            }
          }
        `;

      const searchCategory = this.searchCategory;
      const tenantAlias = this.tenantAlias;
      const orderNumber = this.value.orderNumber;

      let filter = {
        limit: DEFAULT_AMOUNT_OF_RECORDS_TO_RETRIEVE_FROM_BACKEND,
        nextToken
      };

      const searchTransactionLogQuery = {
        searchCategory,
        tenantAlias,
        orderNumber,
        filter
      };

      const searchLogResponse = await API.graphql(
        graphqlOperation(searchTransactionLog, {
          body: searchTransactionLogQuery
        })
      );

      this.nextToken = searchLogResponse.data.searchTransactionLog.nextToken;

      return searchLogResponse.data.searchTransactionLog.data;
    },
    async getFormatedTransactionHistory(nextToken) {
      const transactionHistory = await this.getTransactionHistory(nextToken);
      return transactionHistory.map(this.formatTransactionHistory);
    },
    async loadTransactionHistory(nextToken) {
      this.loading = true;
      try {
        const newTransacitonHistory = await this.getFormatedTransactionHistory(
          nextToken
        );
        this.transactionHistory = this.transactionHistory.concat(
          newTransacitonHistory
        );

        this.transactionHistory.sort(this.sortTransactionHistory);
      } catch (err) {
        this.loading = false;
        throw err;
      }
      this.loading = false;
    },
    async loadMoreTransactionHistory() {
      if (!this.nextToken) return;
      await this.loadTransactionHistory(this.nextToken);
    },
    sortTransactionHistory(h1, h2) {
      return this.sortByDates(h1, h2, true);
    },
    sortByDates(a, b, isDesc) {
      const aDate = new Date(a.logDate);
      const bDate = new Date(b.logDate);
      return this.genericSort(aDate, bDate, isDesc);
    },
    genericSort(a, b, isDesc) {
      const descending = isDesc ? -1 : 1;
      return (a < b ? -1 : 1) * descending;
    },
    extractDateFromTime(dateTime) {
      const date = new Date(dateTime);
      let dateString = date.toDateString();
      dateString = dateString.substr(dateString.indexOf(" ") + 1);
      const timeString = date.toLocaleTimeString();
      return { date: `${dateString}\n${timeString}` };
    },
    formatAmount(amount) {
      amount = parseToFloat(amount).toFixed(2);
      return CURRENCY_FORMATER.format(amount);
    },
    formatTransactionHistory(history) {
      const dateTime = this.extractDateFromTime(history.logDate);
      history.amount = this.formatAmount(history.amount);

      return { ...history, ...dateTime };
    },
    close() {
      this.$emit("close");
    },
    clearData() {
      this.search = "";
      this.loading = false;
      this.transactionHistory = [];
      this.nextToken = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.view-request-btn {
  padding: 0.5rem 1rem;
  border-radius: 4px;
  background-color: #6b68e8;
  color: #ffffff;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
}
</style>
